import styled from 'styled-components'
import { media } from '../../../../../layouts/utils'
export const Container = styled.div`
	margin-top: 2rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	filter: ${({ blur }) => (blur ? 'blur(2px)' : '')};
	.botoesCupons {
		display: flex;
		gap: 2rem;
		${media.phone`
			flex-direction: column !important;
			gap: 1rem;
 		`}
	}
	user-select: ${({ blur }) => (blur ? 'none' : 'auto')};

`
export const Terms = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.875rem;
	color: #FFFFFF;

	font-size: 0.9rem;
	b {
		text-decoration: underline;
		user-select: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
		&:hover {
			filter: brightness(1.2);
		}
	}

	${media.phone`
	font-size: 0.875rem;

 `}
`
export const Link = styled.a`
	text-decoration: none;
	${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
`
export const ModalHeader = styled.div`
	display: flex;
	align-content: center;
	justify-content: flex-end;
	width: 100%;
	height: 40px;
`
export const CloseButton = styled.img`
	width: 1.5rem;
	height: 1.5rem;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	&:hover {
		filter: brightness(2);
	}
`
export const Line = styled.p`
	margin-bottom: 0.75rem;
	font-weight: 100;

	.bold {
		font-weight: bold;
	}
	.italic {
		font-style: italic;
	}
	.underline {
		text-decoration: underline;
	}
	.strike {
		text-decoration: line-through;
	}
`
export const TextBlock = styled.span`
	&.underline {
		text-decoration: underline;
	}
	&.bold {
		font-weight: bold;
	}
	&.italic {
		font-style: italic;
	}
`
